<template>
  <div>
    <div class="flex">
      <h1>Waitlist</h1>
    </div>
    <table>
      <thead>
        <th>Email</th>
        <th>Joined</th>
      </thead>
      <tbody>
        <tr v-for="waitlistEntry in waitlist.data" :key="waitlistEntry.id">
          <td>{{ waitlistEntry.email }}</td>
          <td>{{ waitlistEntry.createdAt | moment("from") }}</td>
        </tr>
      </tbody>
    </table>

    <el-pagination
      class="mt-10"
      :current-page="waitlist.pagination.currentPage"
      layout="pager"
      :total="waitlist.pagination.totalCount"
      @current-change="getWaitlist"
      :page-size="100"
      hide-on-single-page
    />
  </div>
</template>

<script>
import { WAITLIST_QUERY } from "@/api/queries";

export default {
  data() {
    return {
      waitlist: {
        data: [],
        pagination: { currentPage: 1, totalCount: 0 }
      }
    };
  },
  methods: {
    async getWaitlist(page = 1) {
      const { data } = await this.$apollo.query({
        query: WAITLIST_QUERY,
        variables: { pagination: { page } }
      });
      this.waitlist = data.waitlist;
    }
  },
  mounted() {
    this.getWaitlist();
  }
};
</script>
